export const preventDefault = (e) => {
    e.preventDefault && e.preventDefault();
};
const lockBody = (e) => {
    preventDefault(e);
};

export const disableBodyScroll = () => {
    document.body.addEventListener('touchmove', lockBody, { passive: false });
    document.body.classList.add('overflow-y-hidden');
};

export const enableBodyScroll = () => {
    document.body.removeEventListener('touchmove', lockBody);
    document.body.classList.remove('overflow-y-hidden');
};

export const scrollToTop = () => {
    const sTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (sTop > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, sTop - sTop / 8);
    }
};
